export const FULL_CHART_HEIGHT = 500;
export const REDUCED_CHART_HEIGHT = 300;

export const TOOLTIP_CATEGORY_HEADER = "font-semibold indent-5";
export const TOOLTIP_INDENT = "indent-5";
export const TOOLTIP_SEMIBOLD = "font-semibold";
